// Had to add parsley to the JS files seperately.
// Because they were called like this "form.parsley().validate()" and this fails with parsley is not a function.
import "parsleyjs/dist/parsley.min.js";
$(function () {
	if (!$('.cost-calculator-block').length) {
		return;
	}

	$('.js-recalculate').on('click', function (e) {
		e.preventDefault();
		var form = $('#jsCostCalculator');
		if (form.length > 0) {
			form.parsley().validate();
			if (form.parsley().isValid()) {
				recalculateAmounts();
			}
			else {
				emptyValues();
            }
        }
		else {
			emptyValues();
		}

		return false;
	});

	$('.js-employee-type-change').on('change', function (e) {
		employeeTypeChanged(e);
	});

	const employeeTypeChanged = (e) => {
		if (e != "") {
			$('#costcalculatorcontainer select').find('option[name="' + e + '"]').attr("selected", true);
			var employeeTypeName = $("#costcalculatorcontainer select option:selected").html();
			$(".employee-type-name").show();
			$(".employee-type-name span").html(employeeTypeName + " ");
		}

		var income = $("#costcalculatorcontainer select option:selected").val();
		$("#income").val(income);
		$("#costcalculatorcontainer span.amount").html("");
		$("#costcalculatorcontainer span.currency").addClass('hidden');
		var form = $('#jsCostCalculator');
		if (e != "" && form.length > 0) {
			form.parsley().validate();
			if (form.parsley().isValid()) {
				recalculateAmounts();
				e = "";
			}
		}
	}

	const calculateYearlyIncome = (e) => {
		var income = e;
		var yearlyincome = income * 12 * 1.05;

		return yearlyincome;
	}

	const calculateIncomeTaxPercentage = (e) => {
		var yearlyincome = calculateYearlyIncome(e);
		var incometax = calculateIncomeTax(yearlyincome);
		var churchtax = calculateChurchTax(yearlyincome);
		var municipaltax = calculateMunicipalTax(yearlyincome);
		var yearlytax = churchtax + incometax + municipaltax;
		var taxpercentage = Math.round((yearlytax / yearlyincome) * 1000) / 1000;;
		
		return taxpercentage;
	}

	const calculateIncomeTax = (yearlyincome) => {
		var yearlyincome;

		var taxableearnedincome;
		var taxpayablelowestamount;
		var taxonincomepercentage;

		//2020
		//var taxableearnedincome = low end of incomebracket. Just named badly
		if (yearlyincome < 18100) {
			taxableearnedincome = 0;
			taxpayablelowestamount = 0;
			taxonincomepercentage = 0;
		}
		else if (yearlyincome < 27200) {
			taxableearnedincome = 18100;
			taxpayablelowestamount = 8;
			taxonincomepercentage = 0.06;
		}
		else if (yearlyincome < 44800) {
			taxableearnedincome = 27200;
			taxpayablelowestamount = 554;
			taxonincomepercentage = 0.1725;
		}
		else if (yearlyincome < 78500) {
			taxableearnedincome = 44800;
			taxpayablelowestamount = 3590;
			taxonincomepercentage = 0.2125;
		}
		else if (yearlyincome >= 78500) {
			taxableearnedincome = 78500;
			taxpayablelowestamount = 10751;
			taxonincomepercentage = 0.3125;
		}

		var incometax = taxpayablelowestamount + (yearlyincome - taxableearnedincome) * taxonincomepercentage;

		return incometax;
	}

	const calculateChurchTax = (e) => {
		var yearlyincome = e;
		var churchtax = yearlyincome * 0.015;

		return churchtax;
	}

	const calculateMunicipalTax = (e) => {
		var yearlyincome = e;
		var municipaltax = yearlyincome * 0.1983;

		return municipaltax;
	}

    const recalculateAmounts = () => {
		$("#costcalculatorcontainer .error").hide();
		let income = $("#costcalculatorcontainer #income").val();


		if (income > 0) {
			var taxpercentage = calculateIncomeTaxPercentage(income);
			$("#costcalculatorcontainer span.currency").removeClass('hidden');
			$("#employer-cost-1,#employer-cost-2, #employee-receives").removeClass('hidden');

			var incomeTax = Math.round((taxpercentage * 100) * 100) / 100;
			var employeeTax = Math.round((income * (taxpercentage)) * 100) / 100;
			var employeePensionCost = Math.round(income * calculatorValues.pensionCost) / 100;
			var employeeInsurance = Math.round(income * calculatorValues.employeeUnemploymentInsurance) / 100;
			var employerPensionContribution = Math.round(income * calculatorValues.pensionContribution) / 100;
			var employerAccidentInsurance = Math.round(income * calculatorValues.employmentAccidentInsurance) / 100;
			var employerUnemploymentInsurance1 = Math.round(income * calculatorValues.employerUnemploymentInsurance1) / 100;
			var employerUnemploymentInsurance2 = Math.round(income * calculatorValues.employerUnemploymentInsurance2) / 100;
			var employerLifeInsurance = Math.round(income * calculatorValues.groupLifeInsurance) / 100;
			var employerSocialSecurityContribution = Math.round(income * calculatorValues.employersSocialSecurity) / 100;
			var employerBonus = Math.round(income * calculatorValues.monthlyAnnualBonus) / 100;
			var employeeTotal = income - Math.round(employeeTax + employeePensionCost + employeeInsurance);
			var employerTotal1 = Math.round(parseInt(income) + employerPensionContribution + employerAccidentInsurance + employerUnemploymentInsurance1 + employerLifeInsurance + employerSocialSecurityContribution + employerBonus);
			var employerTotal2 = Math.round(parseInt(income) + employerPensionContribution + employerAccidentInsurance + employerUnemploymentInsurance2 + employerLifeInsurance + employerSocialSecurityContribution + employerBonus);
			
			$("span.incometax").html(incomeTax);
			$("#employee-tax span.amount").html(employeeTax);
			$("#employee-pension-cost span.amount").html(employeePensionCost);
			$("#employee-insurance span.amount").html(employeeInsurance);
			$("#employer-pension-contribution span.amount").html(employerPensionContribution);
			$("#employer-accident-insurance span.amount").html(employerAccidentInsurance);
			$("#unemployment-insurance span.amount").html(employerUnemploymentInsurance2);
			$("#employer-life-insurance span.amount").html(employerLifeInsurance);
			$("#employer-social-security-contribution span.amount").html(employerSocialSecurityContribution);
			$("#employer-bonus span.amount").html(employerBonus);
			$("#employee-receives").html("€ " + employeeTotal);
			$("#employer-cost-1").html("€ " + employerTotal1);
			$("#employer-cost-2").html("€ " + employerTotal2);
		}
		else {
			emptyValues();
		}
	}

	const emptyValues = () => {
		$("span.incometax").html("");
		$("#employee-tax span.amount").html("");
		$("#employee-pension-cost span.amount").html("");
		$("#employee-insurance span.amount").html("");
		$("#employer-pension-contribution span.amount").html("");
		$("#employer-accident-insurance span.amount").html("");
		$("#unemployment-insurance span.amount").html("");
		$("#employer-life-insurance span.amount").html("");
		$("#employer-social-security-contribution span.amount").html("");
		$("#employer-bonus span.amount").html("");
		$("#employee-receives").html("");
		$("#employer-cost-1").html("");
		$("#employer-cost-2").html("");
		$("#employee-receives").addClass("hidden");
		$("#employer-cost-1").addClass("hidden");

    }
})